import React from 'react';
import t from 'prop-types';

var AreaImagen = function AreaImagen(_ref) {
  var children = _ref.children;
  return React.createElement('div', {
    className: 'areaImagenVisorImagenes'
  }, children);
};

AreaImagen.propTypes = process.env.NODE_ENV !== "production" ? {
  children: t.any
} : {};
export default AreaImagen;